__turbopack_context__.v({
  "className": "inter_ba8858db-module__-VMama__className",
  "variable": "inter_ba8858db-module__-VMama__variable",
});
